import render from '../../utils/template-renderer';
import { get } from '../../utils/options';

export const itemDefault = render`
  <a href="${props => props.Url}" class="c-featured-content__card" data-content-type="${props => props.Category.ContentType}">
    ${props => props.ImageUrl ? `
      <span class="c-featured-content__card-image">
        <img src="${props.ImageUrl}" width="360" height="200">
      </span>
    ` : null}

    <div class="c-featured-content__card-body">
        <header>
            <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
              ${props => props.Category.Name}
            </div>

            ${props => props.Title ? `
              <h3 class="c-featured-content__card-heading">
                ${props.Title}
              </h3>
            ` : null}
        </header>

        ${props => props.Intro ? `
          <p>${props.Intro}</p>
        ` : null}

        <footer>
          ${props => props.Date ? `
            <span>${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</span>
          ` : null}

          ${props => props.Url ? `
            <span class="c-featured-content__card-read-more">
              <span>${get('read-more')}</span>
            </span>
          ` : null}
        </footer>
    </div>
  </a>
`;

export const itemEvent = render`
  <article class="c-featured-content__card" data-content-type="${props => props.Category.ContentType}" data-url="${props => props.EventOutlookUrl}">
    <div class="c-featured-content__card-date">
      <div class="c-featured-content__card-date-day">
        ${props => moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD')}
      </div>
      <div class="c-featured-content__card-date-month-year">
      ${props => moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('MMMM YY')}
      </div>
    </div>

    <div class="c-featured-content__card-body">
      <header>
        <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
          ${props => props.Category.Name}
        </div>

        ${props => props.Title ? `
          <h3 class="c-featured-content__card-heading">${props.Title}</h3>
        ` : null}
      </header>

      ${props => props.Intro ? `
        <p>${props.Intro}</p>
      ` : null}

      <footer>
        ${props => props.EventOutlookUrl ? `
          <a href="${props.EventOutlookUrl}" class="c-btn c-btn--outline c-btn--secondary c-btn--calendar">
            ${get('add-to-calendar')}
          </a>
        ` : null}
      </footer>
    </div>
  </article>
`;

export const itemSocial = render`
  <a href="${props => props.SocialMedia.MediaUrl.Url}" target="${props => props.SocialMedia.MediaUrl.Target}" class="c-featured-content__card" data-content-type="${props => props.Category.ContentType}">
    ${props => props.ImageUrl ? `
      <div class="c-featured-content__card-image">
        <img src="${props.ImageUrl}" width="360" height="200">
      </div>
    ` : null}

    <div class="c-featured-content__card-body">
      ${props => props.Intro ? `
        <p>${props.Intro}</p>
      ` : null}

      <footer>
        ${props => props.SocialMedia.Type === "Twitter" ? `
          <span>@${props.SocialMedia.TwitterUserName} / ${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</span>
        ` : `
          <span>${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</span>
        `}

        ${props => props.SocialMedia.Icon ? `
          <span class="${props.SocialMedia.Icon}"></span>
        ` : null}
      </footer>
    </div>
  </a>
`;

export const itemImage = render`
  <a href="${props => props.ImageUrl}" class="c-featured-content__card" data-glightbox data-content-type="${props => props.Category.ContentType}">
    ${props => props.ImageUrl ? `
      <div class="c-featured-content__card-image">
        <img src="${props.ImageUrl}" width="360" height="200">
      </div>
    ` : null}

    <div class="c-featured-content__card-body">
      <header>
        <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
          ${props => props.Category.Name}
        </div>

        ${props => props.Title ? `
          <h3 class="c-featured-content__card-heading">${props.Title}</h3>
        ` : null}
      </header>

      ${props => props.Intro ? `
        <p>${props.Intro}</p>
      ` : null}

      <footer>
        ${props => props.Date ? `
          <span>${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</span>
        ` : null}
      </footer>
    </div>
  </a>
`;

export const itemProduct = render`
  <a href="#modal-content-${props => props.Id}" class="c-featured-content__card" data-glightbox data-content-type="${props => props.Category.ContentType}">
  ${props => props.ImageUrl ? `
    <span class="c-featured-content__card-image">
      <img src="${props.ImageUrl}" width="360" height="200">
    </span>
  ` : null}

    <div class="c-featured-content__card-body">
        <header>
            <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
              ${props => props.Category.Name}
            </div>

            ${props => props.Title ? `
              <h3 class="c-featured-content__card-heading">
                ${props.Title}
              </h3>
            ` : null}
        </header>

        <footer class="justify-flex-end">
            <span class="c-featured-content__card-read-more">
              <span>${get('read-more')}</span>
            </span>
        </footer>
    </div>
  </a>

  
  <div style="display:none" id="modal-content-${props => props.Id}">
    <div class="c-featured-content__modal">
      <div class="c-featured-content__modal-content">
        ${props => props.Title ? `
          <h3 class="c-featured-content__modal-heading">
            ${props.Title}
          </h3>
        ` : null}

        ${props => props.Intro ? `
          <div class="c-featured-content__modal-intro">
            ${props.Intro}
          </div>
        ` : null}

        ${props => props.ProductLinkUrl ? `
              <div class="c-featured-content__modal-button">
                  <a href="${props.ProductLinkUrl.Url}" target="${props.ProductLinkUrl.Target}" class="c-btn c-btn--secondary">
                    ${props.ProductLinkUrl.Text}
                  </a>
              </div>
        ` : null}
      </div>

      ${props => props.ImageUrl ? `
      <div class="c-featured-content__modal-media">
          <div class="c-featured-content__modal-image">
            <img src="${props.ImageUrl}" width="360" height="360">
          </div>
      </div>
      ` : null}
    </div>
  </div>
`;

const getVideoSrc = props => {
  const YOUTUBE = 1;
  const VIMEO = 2;
  const INTERNAL = 3;

  if (props.Video.VideoSource === YOUTUBE) {
    return `//www.youtube.com/embed/${props.Video.VideoId}?rel=0&controls=1&showinfo=0&wmode=transparent&autoplay=1mute=0`;
  }
  if (props.Video.VideoSource === VIMEO) {
    return `//player.vimeo.com/video/${props.Video.VideoId}?autopause=0&autoplay=1mute=0`;
  }
  if (props.Video.VideoSource === INTERNAL) {
    return props.Video.InternalVideoUrl;
  }
};

export const itemVideo = render`
  <a href="${getVideoSrc}" class="c-featured-content__card" data-glightbox data-content-type="${props => props.Category.ContentType}">
    ${props => props.ImageUrl ? `
      <div class="c-featured-content__card-image">
        <img src="${props.ImageUrl}" width="360" height="200">
      </div>
    ` : null}

    <div class="c-featured-content__card-body">
      <header>
        <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
          ${props => props.Category.Name}
        </div>

        ${props => props.Title ? `
          <h3 class="c-featured-content__card-heading">${props.Title}</h3>
        ` : null}
      </header>

      ${props => props.Intro ? `
        <p>${props.Intro}</p>
      ` : null}

      <footer>
        ${props => props.Date ? `
          <span>${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</span>
        ` : null}
      </footer>
    </div>
  </a>
`;

export const itemDownload = render`
  <a class="c-featured-content__card" data-content-type="@Model.Category.Name" href="${props => props.PdfUrl}" download>
    ${props => props.ImageUrl ? `
      <div class="c-featured-content__card-image">
        <img src="${props.ImageUrl}" width="360" height="200">
      </div>
    ` : null}

    <div class="c-featured-content__card-body">
      <header>
        <div class="c-featured-content__card-tag" style="background-color: ${props => props.Category.Color}">
          ${props => props.Category.Name}
        </div>

        ${props => props.Title ? `
          <h3 class="c-featured-content__card-heading">${props.Title}</h3>
        ` : null}
      </header>

      ${props => props.Date ? `
        <p>${moment(props.Date, 'YYYY-MM-DDTHH:mm:ssZ').format('DD-MM-YYYY')}</p>
      ` : null}

      <footer>
        ${props => props.PdfUrl ? `
          <span class="c-btn c-btn--outline c-btn--secondary c-btn--download">
            ${get('download')}
          </span>
        ` : null}
      </footer>
    </div>
  </a>
`;

export const subNavigationItem = render`
  <li>
    <a data-id="${props => props.Id}" href="${props => props.Name}" ${props => props.Active ? 'class="active"' : null}>
      ${props => props.Name}
    </a>
  </li>
`;

export const filterItem = render`
  <li class="r-form-check">
    <input type="checkbox" id="filter-year-${props => props.Value}" name="year" value="${props => props.Value}" ${props => props.Selected ? "checked" : ""}>
    <label for="filter-year-${props => props.Value}">${props => props.Value}</label>
  </li>
`;
